import { useQuery } from '@tanstack/react-query';
import { reviewQueries } from '../api/review-queries';

/**
 * The merchant's reviews across every branch. No scope is threaded through:
 * the backend derives the merchant from the caller's token.
 */
export function useReviews() {
  return useQuery(reviewQueries.list());
}
